import { rest } from 'msw';
import { API_ROOT } from 'configs/env-vars';
import { organizationUsers, createOrganizationUser } from '../mockData/organization-users';

const OrganizationUsersApi = [
  rest.post(`${API_ROOT}organizations-users/`, (req, res, ctx) => res(ctx.json(createOrganizationUser))),

  rest.get(`${API_ROOT}organizations-users`, (req, res, ctx) => {
    const organizationId = req.url.searchParams.get('organizationId');
    if (organizationId === '1') {
      return res(ctx.json(organizationUsers));
    }
    return [];
  }),
];
export default OrganizationUsersApi;
